import { render, staticRenderFns } from "./JInput.vue?vue&type=template&id=ef72c124&scoped=true"
import script from "./JInput.vue?vue&type=script&lang=js"
export * from "./JInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef72c124",
  null
  
)

export default component.exports